

































import { Component, Prop, Vue } from 'vue-property-decorator';
import { FamilyManagement, FamilyVersionManagement } from '@/modules/neovehicle/models/family';

@Component
export default class extends Vue {
    @Prop()
    public isOpen: boolean;

    @Prop()
    public familyVersions: FamilyVersionManagement[];

    @Prop()
    public families: FamilyManagement[];

    public isOpenInternal = false;
    public id = 0;

    public headers = [
        { text: 'Código', value: 'id', sortable: false },
        { text: 'Família Versão', value: 'familiaVersionName', sortable: false },
        { text: 'Família', value: 'familyName', sortable: false },
    ];

    public created() {
        this.isOpenInternal = this.isOpen;
    }

    public handleCancel() {
        this.$emit('cancel');
    }

    public handleMove() {
        this.$emit('move-selected', this.id);
    }
}
